import { useContext } from 'react';

import { ChangeRequest, SetChangeRequest } from '../contexts/ChangeRequestContext';

export function useChangeRequestContext() {
  const context = useContext(ChangeRequest);

  if (typeof context === 'undefined') {
    throw new Error('useChangeRequestContext must be used within a ChangeRequestContext.Provider');
  }

  const { changeFlow } = context;
  return { changeFlow };
}

export function useSetChangeRequest() {
  const context = useContext(SetChangeRequest);

  if (typeof context === 'undefined') {
    throw new Error('useSetChangeRequest must be used within a SetChangeRequest.Provider');
  }

  const { setChangeFlow } = context;
  return { setChangeFlow };
}
